import { Request } from '../../../httpClient/serverApi/requests/Request';
import { IResult } from '../../../httpClient/serverApi/types/IResponse';

export interface IPKCEGetAuthorizationCodeParams {
  codeChallenge: string;
  codeChallengeMethod: string;
}

export interface IPKCEGetAuthorizationCodeResult extends IResult {
  authorizationCode: string;
}

export class PKCEGetAuthorizationCodeRequest extends Request<IPKCEGetAuthorizationCodeParams, IPKCEGetAuthorizationCodeResult> {
  constructor(params: IPKCEGetAuthorizationCodeParams) {
    super('pkceGetAuthorizationCode', params);
  }
}
